export const incorrectEmail = 'Please enter a valid email address';

export const allReadySelected = 'User is already selected';
